import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-prudens-bleu-fonce text-white">
      <div className="container-custom py-12">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row md:justify-between gap-8">
            <div className="md:flex-1 text-center md:text-left">
              <h3 className="text-xl font-bold mb-4">Prudens</h3>
              <p className="mb-4 text-gray-300">
                Solutions bienveillantes, technologiques et humaines pour la silver économie.
              </p>
              <div className="flex justify-center md:justify-start">
                <a
                  href="https://www.linkedin.com/company/prudens-france/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-prudens-beige-sable"
                  aria-label="LinkedIn Prudens France"
                >
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
            </div>

            <div className="md:flex-1 text-center">
              <h3 className="text-xl font-bold mb-4">Navigation</h3>
              <ul className="space-y-2">
                <li>
                  <Link to="/qui-sommes-nous" className="text-gray-300 hover:text-white">
                    Qui sommes nous
                  </Link>
                </li>
                <li>
                  <Link to="/residence" className="text-gray-300 hover:text-white">
                    Prudens Résidence
                  </Link>
                </li>
                <li>
                  <Link to="/teleconciergerie" className="text-gray-300 hover:text-white">
                    Prudens Téléconciergerie
                  </Link>
                </li>
              </ul>
            </div>

            <div className="md:flex-1 text-center md:text-right">
              <h3 className="text-xl font-bold mb-4">Contact</h3>
              <address className="not-italic text-gray-300">
                <p className="mb-2">87 rue Saint Aubert</p>
                <p className="mb-2">62000 ARRAS</p>
                <p className="mb-2">
                  <a
                    href="mailto:contact@prudens-france.fr?subject=Demande%20d'information"
                    className="hover:text-white underline-offset-2 hover:underline"
                  >
                    contact@prudens-france.fr
                  </a>
                </p>
                <p>+33 6 26 86 20 99</p>
              </address>
            </div>
          </div>
        </div>
         
         <div className="mt-8 flex justify-center">
          <img
          src="logo.png"
          alt="Logo Prudens"
          className="h-12 md:h-16 object-contain"
          />
         </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p className="flex flex-col md:flex-row items-center justify-center gap-1 md:gap-2">
            <span>&copy; {new Date().getFullYear()} Prudens. Tous droits réservés.</span>
            <span className="hidden md:inline text-gray-500">|</span>
            <Link
              to="/mentions-legales"
              className="text-gray-400 hover:text-white underline-offset-2 hover:underline"
            >
              Mentions légales
            </Link>
            <span className="hidden md:inline text-gray-500">|</span>
            <Link
              to="/confidentialite"
              className="text-gray-400 hover:text-white underline-offset-2 hover:underline"
            >
              Politique de confidentialité
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 